(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["abouts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.about-video-section__media').forEach(function (media) {
      var btn = media.querySelector('.about-video-section__play-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var host = media.dataset.host;
        var id = media.dataset.id;
        var embed = media.querySelector('.about-video-section__embed');
        var src = '';

        if (host === 'youtube') {
          src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        } else if (host === 'vimeo') {
          src = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
        } else {
          return;
        }

        embed.innerHTML = '<iframe src="' + src + '" allow="autoplay; fullscreen" allowfullscreen title="Video"></iframe>';
        embed.hidden = false;
        btn.hidden = true;
        
        // Hide covers when video plays
        media.querySelectorAll('.about-video-section__cover').forEach(function(el) {
          el.style.display = 'none';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
